import React from 'react'
import styled from 'styled-components'
import { Label, Optional } from './sc'

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const OptionalLabel = ({ label }: { label: string }) => (
    <Container>
        <Label>{label}</Label>
        <Optional>Optional</Optional>
    </Container>
)

export default OptionalLabel
